// extracted by mini-css-extract-plugin
export default {"issueDetail":"issueDetail_CVtyYP6","detailContainer":"detailContainer_GoFtsBM","separator":"separator_K_VGl8c"};